<!--我的产品-->
<template>
  <div class="service-tab-content">
    <van-pull-refresh v-model="isDownLoading" @refresh="onDownRefresh">
      <van-list
        v-model="isUpLoading"
        :finished="upFinished"
        finished-text="没有更多了"
        @load="onLoadList"
        :offset="offset"
      >
        <ul v-if="dtWinNumberInfos.length">
          <li
            class="item"
            v-for="(item,index) in dtWinNumberInfos"
            :key="index"
            @click="toProductDetail(item)"
          >
            <div class="top">
              <img
                class="item-logo"
                :src="require(`../../../assets/img/logo/${item.bank}.png`)"
                alt
              >
              <span class="item-name">{{ item.name }}</span>
              <span>-</span>
              <span class="item-bankName">{{ item.bankName }}</span>
              <van-tag round type="primary" class="item-tag">{{ item.custType|custTypeTrans }}</van-tag>
            </div>
            <div class="content van-hairline--bottom">
              <!-- quota 额度 -->
              <div class="content-left">
                <div class="content-left-quota">{{ item.quota | tranNumber }}</div>
                <div class="content-left-text">最高可贷额度(元)</div>
              </div>
              <div class="s-line van-hairline--right"></div>
              <div class="content-right">
                <div>产品利率{{item.rate | formatPercent3}}</div>
              </div>
            </div>
            <div class="bottom" v-if="item.productFeature">
              <svg-icon class="bottom-tip-icon" name="tip_correct"></svg-icon>
              <div class="bottom-tip-text">{{ item.productFeature }}</div>
            </div>
          </li>
        </ul>
      </van-list>
    </van-pull-refresh>
  </div>
</template>

<script>
import { getProductList, getCorpId } from "@/api/user";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      pageSize: 10, // 每页条数
      pageIndex: 1, // pageNum 页码
      dtWinNumberInfos: [], // 请求数据
      isDownLoading: false, // 下拉刷新
      isUpLoading: false, // 上拉加载
      upFinished: false, // 上拉加载完毕
      offset: 100, // 滚动条与底部距离小于 offset 时触发load事件
      corpId: "",
      data: {}
    };
  },
  async created() {
    document.title = `${this.productType}`;
  },
  computed: {
    ...mapGetters(["sessionId", "userInfo", "productType"])
  },
  filters: {
    formatNumber: function(value) {
      return ((value * 1) / 10000).toFixed(0);
    }
  },
  methods: {
    toProductDetail(item) {
      this.$store.commit("product/SET_PRODETAILS", item);

      this.$router.push("/productDetail");
    },

    findAssciate() {
      return new Promise((resolve, reject) => {
        if (this.sessionId) {
          let userType = JSON.parse(this.userInfo).type;
          if (userType === "ent") {
            resolve(JSON.parse(this.userInfo).userId);
          } else {
            // 个人登录查找关联法人的机构号
            getCorpId(this.sessionId).then(res => {
              console.log("res------------", res);
              if (res.respCode == "00000000") {
                if (res.respData != null && res.respData.length > 0) {
                  resolve(res.respData[0].legalPerDetail.userId);
                } else {
                  resolve("");
                }
              } else {
                resolve("");
              }
            });
          }
        }
      });
    },
    async _getProductList() {
      let apiCode;
      let tempObj = {
        sessionId: this.sessionId,
        pageNum: this.pageIndex,
        pageSize: this.pageSize
      };

      if (this.productType == "审批中") {
        apiCode = "SSHJRBPQ011";
      } else if (this.productType == "已发布") {
        this.corpId = await this.findAssciate();
        if (!this.corpId) {
          return this.$dialog
            .confirm({
              title: "提示",
              message: `暂无权限`
            })
            .then(() => {
              // on confirm
              this.$router.go(-1);
            })
            .catch(() => {
              // on cancel
              this.$router.go(-1);
            });
        }
        apiCode = "SSHJRBPQ005";
        tempObj = { ...tempObj, corpId: this.corpId };
      } else if (this.productType == "已关闭") {
        this.corpId = await this.findAssciate();
        if (!this.corpId) {
          return this.$dialog
            .confirm({
              title: "提示",
              message: `暂无权限`
            })
            .then(() => {
              // on confirm
              this.$router.go(-1);
            })
            .catch(() => {
              // on cancel
              this.$router.go(-1);
            });
        }
        apiCode = "SSHJRBPQ010";
        tempObj = { ...tempObj, corpId: this.corpId };
      } else if (this.productType == "已拒绝") {
        apiCode = "SSHJRBPQ013";
        tempObj = {
          ...tempObj
        };
        // apiCode = "SSHJRBPQ010";
      }
      // 获取list
      console.log(tempObj, "tempObj");
      getProductList(apiCode, {
        data: { ...tempObj }
      }).then(res => {
        console.log("请求", res);
        if (res.resCode == "0000") {
          // 请求成功, ****注意返回的数据有所不同
          let isLastPage;
          let list = [];
          if (this.productType == "审批中" || this.productType == "已拒绝") {
            isLastPage = res.data.paramPageInfo.isLastPage;
            list = res.data.paramPageInfo.list;
          } else {
            // 已发布、已关闭
            isLastPage = res.data.bankProductApplyEntityList.isLastPage;
            list = res.data.bankProductApplyEntityList.list;
          }

          this.dtWinNumberInfos = [...this.dtWinNumberInfos, ...list];

          this.isUpLoading = false;
          if (this.isDownLoading) {
            this.isDownLoading = false;
          }
          this.pageIndex++;

          if (isLastPage) {
            this.upFinished = true;
          }
        } else {
          this.isUpLoading = false;
          this.upFinished = true;
          this.$toast(res.resDesc);
        }
      });
    },
    onDownRefresh() {
      // 下拉刷新
      this.dtWinNumberInfos = [];
      this.pageIndex = 1;
      this.upFinished = false;
      this.isDownLoading = true;
      this.onLoadList(); // 加载数据
    },
    onLoadList() {
      // 上拉加载
      this.isUpLoading = true;
      this._getProductList();
    }
  }
};
</script>

<style lang="less" scoped>
.service-tab-content {
  overflow: scroll;
  .item {
    box-sizing: border-box;
    font-size: 16px;
    background-color: #ffffff;
    margin: 10px;
    padding: 15px 12px;
    .top {
      display: flex;
      align-items: center;
      .item-logo {
        width: 25px;
        height: 25px;
      }
      .item-name {
        margin-left: 6px;
        font-size: 15px;
        font-weight: bold;
        color: #333333;
      }
      .item-bankName {
        font-size: 12px;
        color: #333333;
      }
      .item-tag {
        margin-left: auto;
      }
    }

    .content {
      display: flex;
      margin-top: 10px;
      padding-bottom: 10px;
      justify-content: space-between;
      .content-left {
        width: 42%;
        &-quota {
          margin-bottom: 4px;
          line-height: 31px;
          font-size: 22px;
          color: #ffa716;
        }
        &-text {
          font-size: 12px;
          color: #999999;
        }
      }
      .s-line {
        height: 42px;
        width: 1px;
      }
      .content-right {
        flex: 1;
        padding-left: 15px;
        font-size: 12px;
        color: #999999;
        div {
          margin-bottom: 5px;
        }
      }
    }

    .bottom {
      display: flex;
      align-items: center;
      margin-top: 15px;
      .bottom-tip-icon {
        width: 11px;
        height: 11px;
        margin-right: 5px;
        color: #108ee9;
      }
      .bottom-tip-text {
        font-size: 12px;
        color: #666666;
      }
    }
  }
}
</style>>
